export enum Language {
    'GERMAN',
    'ENGLISH'
}
